<template>
    <section v-if="isLoading" class="mt-24 pb-6 ">
        <div class="text-center mb-6">
            <LoadingCircle size=10></LoadingCircle>
        </div>
    </section>

    <div class="lg:flex mt-12 lg:mt-24 gap-12" v-else>
        <div class="lg:w-3/5 text-offBlack">

            <accordion>
                <accordion-item :is-active="key === 0 || index === 0 || isCategorySelected(category.id)"
                                v-for="(category, key, index) in options" :key="category.id" :id="category.id">
                    <!-- This slot will handle the title/header of the accordion and is the part you click on -->
                    <template v-slot:accordion-trigger>
                        <h2 class="h3 accordion_title with-content">{{ category.title }}</h2>
                    </template>
                    <!-- This slot will handle all the content that is passed to the accordion -->
                    <template v-slot:accordion-content>

                        <option-item v-for="option in category.options"
                                     :optionData="option"
                                     :is-active="isOptionActive(option.id)"
                                     :displayAs="category.values"
                                     @remove-add-on="removeAddOn"
                                     @new-add-on="newAddOn"
                                     @open-modal="openModal"
                        ></option-item>

                        <teleport to="main">
                            <template v-for="optionData in category.options">
                                <div class="section-product-configurator modal"
                                     :id="'modal-' + optionData.id + '' + optionData.categoryId"
                                     aria-hidden="true" v-if="optionData.description || optionData.image">
                                    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                        <div class="w-11/12 max-w-6xl mx-auto my-auto modal__container" role="dialog"
                                             aria-modal="true" aria-labelledby="modal-title">
                                            <header class="relative modal__header">
                                                <button class="modal__close" aria-label="Close modal"
                                                        data-micromodal-close></button>
                                            </header>
                                            <main class="bg-white w-full modal__content aspect-w-16 aspect-h-9"
                                                  :id="'modal-' + optionData.id + '' + optionData.categoryId+'-content'">
                                                <div class="p-4 lg:p-8 flex "
                                                     :class="{'gap-8' : optionData.image && optionData.description}">
                                                    <img v-if="optionData.image"
                                                         :title="optionData.title" :alt="optionData.title"
                                                         class="mx-auto h-full" loading="lazy"
                                                         :class="{'w-2/5 h-fit' : optionData.image && optionData.description}"
                                                         :src="optionData.image">
                                                    <div class="overflow-auto" v-if="optionData.description"
                                                         :class="{'w-3/5' : optionData.image && optionData.description}">
                                                        <div class="flex flex-col">
                                                            <h3 class="h4 text-gold mb-4">{{ optionData.title }}</h3>
                                                            <div class="overflow-y-auto max-h-full">
                                                                <div class="wysiwyg mr-4" v-html="optionData.description"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </main>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </teleport>

                    </template>
                </accordion-item>
            </accordion>
            <div class="hidden lg:block btn-wrap mt-6">
                <button class="button primary-alternate"
                        @click="$emit('enquire')">
                    <span>Enquire</span>
                </button>
            </div>
        </div>
            <div class="-ml-6 w-[calc(100%+3rem)] lg:w-2/5 bottom-0 sticky z-30 -mb-20 lg:ml-0 lg:mb-0 ">
                <div class="bottom-0 left-0 z-20 w-full sticky lg:top-0">
                    <div class="lg:flex lg:flex-col lg:gap-4">
                        <Summary
                            :product="product"
                            :customisationtype="customisationtype"
                            :addOns="addOns"
                            :startOverEnabled="true"
                            :removeOptionEnabled="true"
                            :enquireOptionEnabled="true"
                            :viewProductEnabled="false"
                            @enquire="$emit('enquire')"
                            @removeAddOn="removeAddOn"
                            @startOver="$emit('startOver')"
                        ></Summary>
                        <div class="hidden lg:block" v-html="hubspotembed" v-if="hubspotembed"></div>
                    </div>
                </div>
            </div>

    </div>

</template>

<script>
import LoadingCircle from "../loading-circle";
import Summary from "./summary";
import {formatPrice} from "./Functions";
import Accordion from "./accordion";
import AccordionItem from "./accordion-item";
import OptionItem from "./option-item";
import MicroModal from 'micromodal';

const axios = require('axios')

export default {
    components: {OptionItem, Summary, LoadingCircle, Accordion, AccordionItem},
    props: {
        isLoading: {
            required: true
        },
        product: {
            required: true
        },
        hubspotembed: {
            required: false
        },
        customisationtype: {
            // is it landmark or standard?
            required: true
        },
        options: {
            // available options
            required: true
        },
        addOns: {
            // selected options
            required: true
        }
    },
    name: "Configurator",
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        removeAddOn(addOnId) {
            this.$emit('removeAddOn', addOnId)
        },
        newAddOn(addOn) {
            this.$emit('newAddOn', addOn)
        },
        isOptionActive(optionId) {
            return this.addOns.find(x => x.id === optionId) ? true : false;
        },
        openModal(modalId) {
            MicroModal.show(modalId);
        },
        isCategorySelected(categoryId) {
            return this.addOns.find(x => x.categoryId === categoryId) ? true : false;
        }
    },
    setup(props) {

        //

    },
}
</script>